// extracted by mini-css-extract-plugin
module.exports = {"component":"style_component__Xvdd6","text":"style_text__iqREg"};